export default function useGetPlatform() {
    const platform = process.env.REACT_APP_PLATFORM;

    return {
        isGmfPlatform: platform === "GMF",
        platformName: process.env.REACT_APP_PLATFORM_NAME,
    };
}
